import { createSelector } from '@reduxjs/toolkit';

import { createOrderList } from '_helpers/orders';

export const selectFilters = (state) => state.orders.filters;
export const selectParams = (state) => state.orders.params;
export const selectData = (state) => state.orders.data;
export const selectError = (state) => state.orders.error;
export const selectLoading = (state) => state.orders.loading;

export const selectOrderList = createSelector([selectData], (data) => {
  return createOrderList(data);
});
